import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { AccountService, BillingSalesService, CommonService, MainDashboardService } from '../../../services';
import { Subscription, catchError, finalize, forkJoin, of } from 'rxjs';
import { AccountRegionModel } from '../../../models/account.model';
import { SalesInvoiceListViewModel } from '../../../models/billing/sales-invoice.model';
import swal from 'sweetalert2';
import { AccountRegistratinModel } from '../../../models/account/account-registration.model';
import { ClientMainDashModel } from '../../../models/ClientMainDash.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.html',
  styleUrls: [
    './dashboard.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})


export class DashboardPageComponent implements OnInit, OnDestroy {
  regionId: number;
  regionList: AccountRegionModel[] = [];

  private subscripe$: Subscription = new Subscription();
  private dashboardLoad = new Subscription();


  orderQueueData: Array<SalesInvoiceListViewModel> = [];
  loadingQueue: boolean;
  deniedOrdereData: Array<SalesInvoiceListViewModel> = [];
  loadingDeniedOrder: boolean;

  loadingAll: boolean;
  initLoading: boolean;

  selectedNoOfDays = 1;

  registrationQueueData: Array<AccountRegistratinModel> = [];
  loadingRegistrationQueue: boolean;

  accountRegionData: Array<ClientMainDashModel> = [];
  loadingAccountRegion: boolean;

  constructor(private authService: AuthService, private common: CommonService,
    private billingSvc: BillingSalesService, private svc: AccountService,
    private srv: MainDashboardService) { }

  ngOnInit() {
    this.init();
    this.subscripe$.add(this.common.selectedRegionsChange$.subscribe((list: AccountRegionModel[]) => {
      this.regionList = list || [];
      this.getDatas();
    }));
  }

  init() {
    this.regionId = Number.parseInt((localStorage.getItem('current_region') ? localStorage.getItem('current_region') : this.authService.getRegion()) ?? undefined);
    this.regionList = this.common.selectedRegions;
    if (this.regionList?.length > 0) {
      this.getDatas();
    }
  }

  getDatas() {
    // Cancel the previous selection before accepting any new region responses.
    this.dashboardLoad.unsubscribe();
    const regions = [...this.regionList];
    this.orderQueueData = [];
    this.deniedOrdereData = [];
    this.registrationQueueData = [];
    this.accountRegionData = [];
    this.loadingAll = regions.length > 0;
    this.initLoading = this.loadingAll;
    if (!regions.length) {
      this.common.onLoadingRegionChange(-1);
      return;
    }

    this.common.onLoadingRegionChange(regions[0].id);
    // Selection order does not determine which request finishes last.
    this.dashboardLoad = forkJoin(regions.map(region => forkJoin({
      orderQueue: this.billingSvc.getQueueInvoices(region.id).pipe(catchError(error => this.loadError(error))),
      deniedOrder: this.billingSvc.getDeniedInvoices(region.id, this.selectedNoOfDays).pipe(catchError(error => this.loadError(error))),
      registrationQueue: this.svc.getRegistrationByRegion(region.id).pipe(catchError(error => this.loadError(error))),
      accountRegion: this.srv.getAccounts(region.id).pipe(catchError(error => this.loadError(error)))
    }))).pipe(finalize(() => {
      this.initLoading = false;
      this.loadingAll = false;
      this.common.onLoadingRegionChange(-1);
    })).subscribe(results => {
      results.forEach((data, index) => {
        const region = regions[index].name;
        this.onGetOrderQueue(data.orderQueue, region);
        this.onGetDeniedOrder(data.deniedOrder, region);
        this.onGetRegistrationQueue(data.registrationQueue, region);
        this.onGetAccountRegion(data.accountRegion, region);
      });
    });
  }

  refreshOrderQueue() {
    this.orderQueueData = [];
    const list: any = {};
    this.regionList.forEach((x, i) => {
      list[`orderQueue${i}`] = this.billingSvc.getQueueInvoices(x.id).pipe(catchError(error => this.loadError(error)));
    });
    this.loadingQueue = true;
    forkJoin(list).toPromise().then((data: any) => {
      this.loadingQueue = false;
      if (data) {
        Object.keys(data || {}).forEach((d, j) => {
          if (d) {
            this.onGetOrderQueue(data[d], this.regionList[j].name);
          }
        })
      }
    });
  }

  onGetOrderQueue(data, region) {
    if (data?.result) {
      const rows = data.result.map(x => {
        const parseData = SalesInvoiceListViewModel.parse(x);
        parseData['region'] = region;
        return parseData;
      });
      this.orderQueueData = [...this.orderQueueData, ...rows];
    } else if(data?.errorMessage) {
      this.onGetError(data?.errorMessage);
    }
  }


  refreshDeniedOrder(noOfDays: number) {
    this.selectedNoOfDays = noOfDays;
    this.deniedOrdereData = [];
    const list: any = {};
    this.regionList.forEach((x, i) => {
      list[`deniedOrder${i}`] = this.billingSvc.getDeniedInvoices(x.id, this.selectedNoOfDays).pipe(catchError(error => this.loadError(error)));
    });
    this.loadingDeniedOrder = true;
    forkJoin(list).toPromise().then((data: any) => {
      this.loadingDeniedOrder = false;
      if (data) {
        Object.keys(data || {}).forEach((d, j) => {
          if (d) {
            this.onGetDeniedOrder(data[d], this.regionList[j].name);
          }
        })
      }
    });
  }

  onGetDeniedOrder(data, region) {
    if (data?.result) {
      const rows = data.result.map(x => {
        const parseData = SalesInvoiceListViewModel.parse(x);
        parseData['region'] = region;
        return parseData;
      });
      this.deniedOrdereData = [...this.deniedOrdereData, ...rows];
    } else if(data?.errorMessage) {
      this.onGetError(data?.errorMessage);
    }
  }

  refreshRegistrationQueue() {
    this.registrationQueueData = [];
    const list: any = {};
    this.regionList.forEach((x, i) => {
      list[`registrationQueue${i}`] = this.svc.getRegistrationByRegion(x.id).pipe(catchError(error => this.loadError(error)));
    });
    this.loadingRegistrationQueue = true;
    forkJoin(list).toPromise().then((data: any) => {
      this.loadingRegistrationQueue = false;
      if (data) {
        Object.keys(data || {}).forEach((d, j) => {
          if (d) {
            this.onGetRegistrationQueue(data[d], this.regionList[j].name);
          }
        })
      }
    });
  }

  onGetRegistrationQueue(data, region) {
    if (data?.result) {
      const rows = data.result.map(x => {
        const parseData = AccountRegistratinModel.parse(x);
        parseData['region'] = region;
        return parseData;
      });
      this.registrationQueueData = [...this.registrationQueueData, ...rows];
    } else if(data?.errorMessage) {
      this.onGetError(data?.errorMessage);
    }
  }

  refreshAccountRegion() {
    this.accountRegionData = [];
    const list: any = {};
    this.regionList.forEach((x, i) => {
      list[`accountRegion${i}`] = this.srv.getAccounts(x.id).pipe(catchError(error => this.loadError(error)));
    });
    this.loadingAccountRegion = true;
    forkJoin(list).toPromise().then((data: any) => {
      this.loadingAccountRegion = false;
      if (data) {
        Object.keys(data || {}).forEach((d, j) => {
          if (d) {
            this.onGetAccountRegion(data[d], this.regionList[j].name);
          }
        })
      }
    });
  }

  onGetAccountRegion(data, region) {
    if (data?.result) {
      const rows = data.result.map(x => {
        const parseData = ClientMainDashModel.parse(x);
        parseData['region'] = region;
        return parseData;
      });
      // Angular's pure activeFilter pipe needs a new array reference.
      this.accountRegionData = [...this.accountRegionData, ...rows];
    } else if(data?.errorMessage) {
      this.onGetError(data?.errorMessage);
    }
  }

  private loadError(error: any) {
    return of({ errorMessage: error?.error?.errorMessage || error?.errorMessage || error?.message || 'Unable to load dashboard data.' });
  }

  onGetError(err) {
    this.onError(err);
  }
  onError(msg) {
    swal({
      position: 'top-end',
      type: 'error',
      title: 'Oops...',
      text: msg || '',
      footer: '<a href>Why do I have this issue?</a>'
    });
  }


  ngOnDestroy(): void {
    this.dashboardLoad.unsubscribe();
    this.subscripe$?.unsubscribe();
  }

}
